import React from 'react';
import useDpemetasUpdateCacheAll from '../hooks/DpemetasUpdateCacheAll';
import { Button, Popconfirm } from 'antd';

const ButtonReloadCache = () => {
  const { handleReloadCache, isLoading } = useDpemetasUpdateCacheAll();

  return (
    <Popconfirm title='Are you sure?' onConfirm={handleReloadCache}>
      <Button className='pl0' loading={isLoading} icon='reload' type='link' size='small'>
        Reload Cache
      </Button>
    </Popconfirm>
  );
};

export default ButtonReloadCache;
